const autocompleteOptions = [
    { text: 'How do I close out my business bank and/or credit card account(s)?', topic: 'Banks' },
    { text: 'How do I manage old bank or credit card accounts?', topic: 'Banks' },
    { text: 'Can I set up a bank account with this bank?', topic: 'Banks' },
    { text: 'How do I connect my bank account?', topic: 'Banks' },
    { text: 'How do I transfer funds from my business checking account to my personal account?', topic: 'Banks' },
    { text: 'How do I handle mixed personal and business activity?', topic: 'Business Finances' },
    { text: 'How do I reimburse myself for expenses?', topic: 'Expenses & Purchases' },
    { text: 'How do I submit expenses I paid for out of my personal accounts?', topic: 'Expenses & Purchases' },
    {
        text: 'How do I notify Collective of new business accounts or large transactions?',
        topic: 'Expenses & Purchases',
    },
    { text: 'How do I categorize an expense?', topic: 'Expenses & Purchases' },
    { text: 'How do I record a loan to my business in my books?', topic: 'Expenses & Purchases' },
    {
        text: 'How do I notify Collective about the nature of a large business transaction?',
        topic: 'Expenses & Purchases',
    },
    { text: 'How do I handle backdated reimbursements?', topic: 'Expenses & Purchases' },
    { text: 'Can I buy something and deduct it as a business expense?', topic: 'Expenses & Purchases' },
    {
        text: 'Can I reimburse myself for a purchase and deduct it as a business expense?',
        topic: 'Expenses & Purchases',
    },
    { text: 'Can I deduct this expense?', topic: 'Expenses & Purchases' },
    { text: 'How do my business transactions get categorized?', topic: 'Financial Statements' },
    { text: "How do I understand my business' financial statements?', topic: 'Financial Statements" },
    {
        text: 'How do I request that a categorized transaction be categorized differently (one-time or all similar transactions go-forward)?',
        topic: 'Financial Statements',
    },
    { text: 'Why was a transaction categorized the way it was?', topic: 'Financial Statements' },
    { text: 'How do I upload my bank statements?', topic: 'Financial Statements' },
    {
        text: 'What do I need to do so that the Collective team can generate my monthly financial statements?',
        topic: 'Financial Statements',
    },
    { text: 'What is the status of my monthly financials?', topic: 'Financial Statements' },
    {
        text: 'I need my monthly financial statements by a specific date. What do I need to do so that Collective can accommodate this?',
        topic: 'Financial Statements',
    },
    { text: 'How do I approve my year-end financial statements?', topic: 'Financial Statements' },
    {
        text: 'What do I need to do to record the business portion of my mixed-use expenses (such as home office, phone, and internet)?',
        topic: 'Financial Statements',
    },
    { text: 'How do I modify my invoices?', topic: 'Invoicing' },
    { text: 'How do I send an invoice?', topic: 'Invoicing' },
    { text: 'Can I get a copy of an invoice emailed to my inbox when I send it to my client?', topic: 'Invoicing' },
    { text: 'Can I add/remove/change an item on my invoices?', topic: 'Invoicing' },
    { text: 'Can I match an invoice to multiple payments?', topic: 'Invoicing' },
    { text: 'Can my clients pay invoices using AutoPay?', topic: 'Invoicing' },
    { text: 'How do I finalize my books for the year?', topic: 'Tax Filing' },
    { text: 'What do I need to do to close my business?', topic: 'Business Closure' },
    { text: 'How can Collective help with closing my business?', topic: 'Business Closure' },
    { text: 'How long will offboarding take?', topic: 'Membership Cancellation' },
    {
        text: 'What does Collective provide me with when I close my business and terminate membership?',
        topic: 'Membership Cancellation',
    },
    { text: 'Why did you charge me?', topic: 'Billing' },
    { text: 'How do I provide Collective with Feedback?', topic: 'Feedback' },
    { text: "How do I update my personal details in Collective's application?", topic: 'Member Profile' },
    { text: 'How do I update my payment method?', topic: 'Member Profile' },
    { text: 'How do I find something on my dashboard?', topic: 'Navigation' },
    { text: "Why can't I see something on my dashboard?", topic: 'Navigation' },
    { text: 'How do I schedule an appointment with my member relationship manager?', topic: 'Proactive Outreach' },
    { text: 'When will I receive my refund or credit?', topic: 'Refunds' },
    { text: 'How do I register my company for a business registration number?', topic: 'Entity Formation or Takeover' },
    { text: 'How long will it take to get my LLC formed?', topic: 'Entity Formation or Takeover' },
    { text: 'What am I responsible for to complete business setup?', topic: 'Business Setup' },
    {
        text: 'I would like to complete my business setup experience by a specific date. What do I need to do for Collective to accommodate this?',
        topic: 'Business Setup',
    },
    { text: 'How do I pay a contractor?', topic: 'Contractors' },
    { text: 'Does my health ministry count as health insurance for a tax deduction?', topic: 'Health Insurance' },
    {
        text: 'Does my health insurance need to be in my business name for me to receive tax benefits from my insurance?',
        topic: 'Health Insurance',
    },
    { text: "What happens if I need to pause my business and can't run payroll?", topic: 'Payroll' },
    { text: 'How do I set up my health insurance on payroll?', topic: 'Payroll' },
    { text: 'How do I run a payroll?', topic: 'Payroll' },
    { text: 'How do I see my W-2 and other payroll documents?', topic: 'Payroll' },
    { text: 'How do I issue a W-2 or 1099?', topic: 'Payroll' },
    { text: 'How do I verify if money from payroll is going to the correct place?', topic: 'Payroll' },
    { text: 'How do I resubmit a payroll payment after an error?', topic: 'Payroll' },
    {
        text: "When I'm applying for health insurance with the state, how much do I put on my state health website for my income?",
        topic: 'Health Insurance',
    },
    { text: 'How can I update my payroll benefits (health insurance, retirement, etc.)?', topic: 'Payroll' },
    { text: 'How can I customize my referral code?', topic: 'Referral' },
    { text: 'How do I refer someone to Collective?', topic: 'Referral' },
    { text: 'How do I benefit from referring members to Collective?', topic: 'Referral' },
    { text: "When will I get paid if I've referred someone?", topic: 'Referral' },
    {
        text: "What do I need to do with third party mail I've received instructing me to file something?",
        topic: 'Compliance',
    },
    {
        text: "How do my business' financial statements impact my quarterly tax estimates and tax returns?",
        topic: 'Financial Statements',
    },
    { text: 'How do I move my LLC to a new state?', topic: 'Foreign Entity' },
    {
        text: 'I had an R&D study done outside of Collective - how do I notify the Collective team of the results?',
        topic: 'R&D Credit',
    },
    { text: 'How do I set up a retirement plan?', topic: 'Retirement' },
    { text: 'How much can I contribute to my retirement plan?', topic: 'Retirement' },
    { text: 'What types of retirement plans can I set up?', topic: 'Retirement' },
    { text: 'What are the deadlines for making contributions to my retirement plan?', topic: 'Retirement' },
    { text: 'What are the benefits of being an S Corp?', topic: 'S Corporation' },
    { text: 'How much did I save last year by operating my business as an S Corp?', topic: 'Tax Filing' },
    {
        text: 'I need my business tax return by a specific date. What do I need to do so that the Collective team can accommodate this?',
        topic: 'Tax Filing',
    },
    {
        text: 'What is a tax extension? Why is my business (or individual) return on extension?',
        topic: 'Tax Extensions',
    },
    { text: 'What am I responsible for to complete my business tax return?', topic: 'Tax Filing' },
    { text: 'What am I responsible for to complete my individual tax return?', topic: 'Tax Filing' },
    { text: 'How do I download my business return?', topic: 'Tax Filing' },
    { text: 'How do I download my individual tax return?', topic: 'Tax Filing' },
    { text: 'What is the status of my business tax return?', topic: 'Tax Filing' },
    { text: 'What is the status of my individual tax return?', topic: 'Tax Filing' },
    {
        text: 'I need my individual tax return by a specific date. What do I need to do so that the Collective team can accommodate this?',
        topic: 'Tax Filing',
    },
    { text: 'How do I sign my 2553?', topic: 'Tax Filing' },
    { text: 'What do I do if I owe money to the state or federal government?', topic: 'Tax Filing' },
    { text: 'How do I record a tax return payment in my Collective dashboard?', topic: 'Tax Filing' },
    { text: 'I received a tax notice. What do I need to do?', topic: 'Tax Notices' },
    { text: 'How do I pay the tax due, penalties, or interest listed on my tax notice?', topic: 'Tax Notices' },
    { text: 'What can I do to pay less in taxes this year and in the future?', topic: 'Tax Strategy' },
    { text: 'How do I navigate the tax process for my business?', topic: 'Tax Strategy' },
    { text: 'How can I understand how my quarterly tax estimate was calculated?', topic: 'Quarterly Tax Estimates' },
    { text: 'How can I request a recalculation of my quarterly tax estimate?', topic: 'Quarterly Tax Estimates' },
    { text: 'How do I record a quarterly tax payment?', topic: 'Quarterly Tax Estimates' },
    { text: 'Why is my quarterly tax estimate so high/low?', topic: 'Quarterly Tax Estimates' },
];

export default autocompleteOptions;
